import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/jobLabourRates'
import Component from 'components/JobLabourRates'

export default createListViewContainer({ actions, selectors: selectors.jobLabourRates })(Component)
